<template>
    <div class="user-panel">
        <header>Zgody</header>
        <ul class="agreements-list">
            <li v-for="(item, i) in agreements" :key="'Agreements_' + i">
                <panel-agreements-item :item="item" :index="i" />
            </li>
        </ul>
    </div>
</template>

<script>
import { getMyFx }from '@/mixins/get-my-fx';
import PanelAgreementsItem from '@/views/myFx/partial/_PanelAgreementsItem'

export default {
    data() {
        return {
            
        }
    },
     components: {
        PanelAgreementsItem
    },
    mixins: [
        getMyFx
    ],
    computed: {
        agreements() {
            return this.myFx ? this.myFx.agreements : false
        }
    }
}
</script>

